import { useCurrentUser } from "@/libs/apis/onboarding/useUser";
import useUserFavoriteTokens, {
  PostUserFavorites,
} from "@/src/hooks/favorites/useUserFavoriteTokens";

type Props = Omit<PostUserFavorites, "swooshHandle"> & { keys?: string[] };

export function useCurrentUserFavoritedTokens(props: Props) {
  const user = useCurrentUser();
  const favoritedTokens = useUserFavoriteTokens({
    ...props,
    swooshHandle: user.currentUser?.swooshHandle as string,
  });

  return favoritedTokens;
}
